<template>
    <div style="height: 92vh;width: 250px">
        <div class="sidebar">
            <el-menu
                    class="sidebar-el-menu"
                    :default-active="onRoutes"
                    :collapse="collapse"
                    text-color="black"
                    active-text-color="#20a0ff"
                    unique-opened
                    router
            >
                <template v-for="item in items">
                    <template v-if="item.subs">
                        <el-submenu :index="item.index" :key="item.index">
                            <template slot="title">
                                <i :class="item.icon"></i>
                                <span slot="title">{{ item.title }}</span>
                            </template>
                            <template v-for="subItem in item.subs">
                                <el-submenu
                                        v-if="subItem.subs"
                                        :index="subItem.index"
                                        :key="subItem.index"
                                >
                                    <template slot="title">{{ subItem.title }}</template>
                                    <el-menu-item
                                            v-for="(threeItem,i) in subItem.subs"
                                            :key="i"
                                            :index="threeItem.index"
                                    >{{ threeItem.title }}</el-menu-item>
                                </el-submenu>
                                <el-menu-item
                                        v-else
                                        :index="subItem.index"
                                        :key="subItem.index"
                                >{{ subItem.title }}</el-menu-item>
                            </template>
                        </el-submenu>
                    </template>
                    <template v-else>
                        <el-menu-item :index="item.index" :key="item.index">
                            <i :class="item.icon"></i>
                            <span slot="title">{{ item.title }}</span>
                        </el-menu-item>
                    </template>
                </template>
            </el-menu>
        </div>

    </div>
</template>

<script>
    import bus from "../../../components/common/bus";
    export default {
        name: "leftSide",
        data() {
            return {
                collapse: false,
                items: [
                    {
                        icon: '',
                        index:'myCode',
                        title:'我的推广码'
                    },
                    {
                        icon: '',
                        index:'customerList_qy',
                        title:'企业客户列表'
                    },
                    {
                        icon: '',
                        index:'customerList_gr',
                        title:'个人客户列表'
                    }
                ]
            };
        },
        computed: {
            onRoutes() {
                return this.$route.path.replace('/', '');
            }
        },
        created() {
            // 通过 Event Bus 进行组件间通信，来折叠侧边栏
            bus.$on('collapse', msg => {
                this.collapse = msg;
                bus.$emit('collapse-content', msg);
            });
        }
    }
</script>

<style scoped>
    /deep/.el-menu{
        width: 250px;
        height: 100%;
    }
    .sidebar {
        z-index: 10;
        display: block;
        position: absolute;
        left: 0;
        top: 7vh;
        bottom: 0;

    }
    .sidebar::-webkit-scrollbar {
        width: 0;
    }
    .sidebar-el-menu:not(.el-menu--collapse) {
        width: 250px;
    }
    .sidebar > ul {
        height: 100%;
    }
</style>
